import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import AdvertiserMainView from '../main/AdvertiserMainView';
import AdvertiserMainLoader from '../../../../core/components/advertiser/AdvertiserMainLoader';
import AdvertiserDetailsView from '../details/AdvertiserDetailsView';
import AdvertiserDetailsLoader from '../../../../core/components/advertiser/advertiserdetails/AdvertiserDetailsLoader';
import AdvertiserDetailsController from '../../../../core/components/advertiser/advertiserdetails/AdvertiserDetailsController';
import { TagProvider } from '../../../../core/components/tags/TagProvider';

const AdvertiserRoutes = (props) => {
  const { path } = props.match;

  return (
    <div>
      <Switch>
        <Route
          exact
          path={`${path}/details/:id?`}
          render={() => (
            <TagProvider>
              <AdvertiserDetailsLoader>
                <AdvertiserDetailsController>
                  <AdvertiserDetailsView />
                </AdvertiserDetailsController>
              </AdvertiserDetailsLoader>
            </TagProvider>
          )}
        />
        <Route
          path={`${path}/main/:pageNumber?`}
          exact
          render={() => (
            <TagProvider>
              <AdvertiserMainLoader>
                <AdvertiserMainView />
              </AdvertiserMainLoader>
            </TagProvider>
          )}
        />
        {/* Fallback */}
        <Route path={`${path}`} render={() => <Redirect to={`${path}/main/1`} />} />
      </Switch>
    </div>
  );
};

export default AdvertiserRoutes;
